import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import './index.css';
import { store } from './store';
import App from './App';
import { SocketProvider } from './contexts/socketContext';
import { register } from './serviceWorkerRegistration';

polyfillCountryFlagEmojis();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <SocketProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </SocketProvider>
  </React.StrictMode>
);

// Register service worker — enables PWA features
register({
  onUpdate: (registration) => {
    const worker = registration.waiting;
    if (worker) {
      // Dispatch an event to show the update prompt instead of force reloading
      window.dispatchEvent(new CustomEvent('app-update', { detail: { worker } }));
    }
  },
});
